import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getChuongTrinhState = state => state.chuongTrinh;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_LIST_API,
    formData
  )

  return handleRequest(request);
}

function listNganhHangRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_NGANHHANG_LIST_API,
    formData
  )

  return handleRequest(request);
}

function listProductRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_PRODUCT_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function chuongTrinhUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function chuongTrinhUpdateProductRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHUONGTRINH_UPDATE_PRODUCT_API,
    formData
  )

  return handleRequest(request);
}

function* chuongTrinhListRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhListSuccess(results.data))

  } catch (error) {
    yield put(brActions.chuongTrinhListError(error))
  }
}

function* chuongTrinhNganhHangListRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const results = yield call(listNganhHangRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhNganhHangListSuccess(results.data))

  } catch (error) {
    yield put(brActions.chuongTrinhNganhHangListError(error))
  }
}

function* chuongTrinhProductListRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const results = yield call(listProductRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhProductListSuccess(results.data))

  } catch (error) {
    yield put(brActions.chuongTrinhProductListError(error))
  }
}

function* chuongTrinhDetailRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.chuongTrinhDetailError(error))
  }
}

function* chuongTrinhUpdateRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const result = yield call(chuongTrinhUpdateRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.chuongTrinhUpdateError(error))
  }
}

function* chuongTrinhUpdateProductRequestFlow() {
  const chuongTrinh = yield select(getChuongTrinhState);
  try {
    // grab the client from our action
    const result = yield call(chuongTrinhUpdateProductRequestApi, chuongTrinh.formData)

    // dispatch the action with our widgets!
    yield put(brActions.chuongTrinhUpdateProductSuccess(result));
  } catch (error) {
    yield put(brActions.chuongTrinhUpdateProductError(error))
  }
}

function* chuongTrinhWatcher() {
  yield [
    takeLatest(Constants.CHUONGTRINH_LIST_REQUESTING, chuongTrinhListRequestFlow),
    takeLatest(Constants.CHUONGTRINH_NGANHHANG_LIST_REQUESTING, chuongTrinhNganhHangListRequestFlow),
    takeLatest(Constants.CHUONGTRINH_PRODUCT_LIST_REQUESTING, chuongTrinhProductListRequestFlow),
    takeLatest(Constants.CHUONGTRINH_DETAIL_REQUESTING, chuongTrinhDetailRequestFlow),
    takeLatest(Constants.CHUONGTRINH_UPDATE_REQUESTING, chuongTrinhUpdateRequestFlow),
    takeLatest(Constants.CHUONGTRINH_UPDATE_PRODUCT_REQUESTING, chuongTrinhUpdateProductRequestFlow),
  ]
}

export default chuongTrinhWatcher



// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/sagas.js